declare namespace $ {

	export class $mol_icon_shape extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=shape.view.tree.d.ts.map